import {
    Card,
    Colors,
    Heading,
    Icon,
    ItemList,
    Pills,
    Text,
    type ListItemData,
} from '@amelio/ui-library';

import { useAmelioTranslations } from '@/hooks';

interface ResultsVisibilityProps {
    managerAccessList: ListItemData[];
}

const ResultsVisibility = ({ managerAccessList }: ResultsVisibilityProps) => {
    const { t } = useAmelioTranslations();

    return (
        <Card
            className={'mt-12'}
            bgColor={'bg-white'}
            borderRadius={'2xl'}
            padding={'xl'}
        >
            <div className={'flex items-center'}>
                <Icon
                    name={'security-eye'}
                    size={'xl'}
                    className={'mr-3'}
                />

                <Heading level={5}>
                    {t('evaluation360ScheduleCreation.resultsVisibility.title')}
                </Heading>
            </div>

            <div className={'mt-8 flex flex-row justify-between gap-2'}>
                <Text className={'flex-1 sm:flex-none'}>
                    {t('evaluation360ScheduleCreation.resultsVisibility.managerAccess')}
                </Text>

                <Pills
                    size={'md'}
                    variant={'primary'}
                >
                    {t('evaluation360ScheduleCreation.resultsVisibility.fullAccess')}
                </Pills>
            </div>

            <div className={'mt-2'}>
                <ItemList items={managerAccessList} />
            </div>

            <div className={'mt-10'}>
                <Text>{t('evaluation360ScheduleCreation.resultsVisibility.employeeAccess')}</Text>

                <Text
                    size={'small'}
                    color={Colors.BASE}
                    className={'mt-2'}
                >
                    {t('evaluation360ScheduleCreation.resultsVisibility.noAccessMessage')}
                </Text>
            </div>
        </Card>
    );
};

export { ResultsVisibility };
